import React from "react";
import { useNavigate } from "react-router-dom";
import { BRAND_PRIMARY } from "./styles";

interface CategoryCardProps {
	label: string;
	description: string;
	icon: React.ReactNode;
	to: string;
	/** The question this card answers. Used by the report cards, where two of the three are
	 *  easy to confuse and the description alone does not separate them. */
	question?: string;
}

const CategoryCard = ({
	label,
	description,
	icon,
	to,
	question,
}: CategoryCardProps) => {
	const navigate = useNavigate();

	return (
		<div
			role="button"
			tabIndex={0}
			className="cursor-pointer rounded-lg border border-gray-200 p-4 flex flex-col gap-2 transition-colors hover:border-[#4F16C2]"
			onClick={() => navigate(to)}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					navigate(to);
				}
			}}
		>
			<span className="text-2xl" style={{ color: BRAND_PRIMARY }}>
				{icon}
			</span>
			<span className="font-medium">{label}</span>
			<span className="text-xs text-gray-500">{description}</span>
			{question && (
				<span className="text-xs italic text-[#4F16C2] mt-1">
					{question}
				</span>
			)}
		</div>
	);
};

export default CategoryCard;
